import Home from "./pages/Newsletter/Home";

const Newsletter = ({ lang }) => {
  return <Home lang={lang} />;
};

export default Newsletter;
